module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm09_intro"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INTRODUCTION")]), _c('br'), _c('strong', [_vm._v("Leadership Character")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Have you ever noticed how many books are written to help leaders improve? As many books as there are out there focused on helping leaders enhance their skills, there are far fewer written to help the leader with the all-important self-work—the part on the inside. That’s why I’m excited about this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ll let you in on a little discussed fact about leadership: As important as the skills are, lack of skills is not what derails most leaders; skills are too easy to learn. If you want to predict people’s ultimate success as leaders, evaluate not their skills but their "), _c('strong', [_vm._v("leadership character")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The challenge of growing our leadership character is complicated by a lack of clarity as to what we’re actually discussing when the term is used. Ask people what character traits they look for in leaders, and I’m guessing they will probably name attributes like integrity, honesty, and, perhaps, loyalty. These alone are not a great answer. Don’t get me wrong—these are fine traits, but they are totally inadequate when describing leadership character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("The best leaders must certainly be honest and have integrity, but we expect these qualities from everyone in our organizations. There are additional traits that set leaders apart. This book is about identifying and developing leadership character. When these traits are evident—and a leader possesses the requisite leadership skills—you find people eager to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, why is a book like this necessary? This book is intended to help leaders and aspiring leaders strengthen their leadership character, and, as a consequence, position themselves for greater opportunity, influence, and impact. For some of you, the ideas in this book may help transform your leadership and unlock opportunities as you’ve never imagined. It might even change your life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you and I can embrace and cultivate the leadership character traits outlined in this simple story and master the skills needed to lead, our organizations will soar. It will require both—character and skills. Let’s begin the hard part today: leadership character first.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6baa0b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm09_intro.vue
// module id = 81
// module chunks = 0